module.exports = __webpack_public_path__ + "band_8.d450eaf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/male_to_female/band_8.png
// module id = RWdu
// module chunks = 0